import React from "react";
import ReactApexChart from "react-apexcharts";

const RadialChart = ({ series, labels, total, colors }) => {
  const options = {
    chart: { type: "radialBar", height: 350 },
    plotOptions: {
      radialBar: {
        hollow: { size: "45%" },
        track: { show: true, margin: 12 },
        dataLabels: {
          name: { fontSize: "22px" },
          value: { fontSize: "16px" },
          total: {
            show: true,
            label: "Total",
            formatter: () => total || 0,
          },
        },
      },
    },
    labels,
    colors,
  };

  return (
    <React.Fragment>
      <ReactApexChart
        options={options}
        series={series}
        type="radialBar"
        height={350}
        className="apex-charts"
      />
    </React.Fragment>
  );
};

export default RadialChart;
